
import {OrderAction, PositionEffect} from './types';

interface StringMap { [s: number]: string; }

export interface StrStrMap { [s: string]: string; }

export const OrderSideMap: any = {
        0: 'Unknown',
        1: 'Buy',
        2: 'Sell',
        Buy: 1,
        Sell: 2,
    };

export const AssetTypeMap: any = {
    1: 'Equity',
    2: 'Option',
    3: 'MutualFund',
    4: 'Bond',
    0: 'Undefined',
    E: 'Equity',
    O: 'Option',
    F: 'MutualFund',
    B: 'Bond',
    U: 'Undefined',
};

export const AssetTypeConvMap: any = {
    E: 1,
    O: 2,
    F: 3,
    B: 4,
    U: 0,
};
export const OrderDurationMap: StringMap = {
    0: 'Unknown',
    1: 'Day',
    2: 'GTC',
    3: 'ETH',
    4: 'Manual',
};

export const PositionEffectMap: any = {
    0: 'Unknown',
    1: 'Open',
    2: 'Close',
    Unknown: 0 ,
    Open: 1 ,
    Close: 2,
};

export const OrderTypeMap: StringMap = {
    0: 'Unknown',
    1: 'Market',
    2: 'Limit',
    3: 'Stop Market',
    4: 'Stop Limit',
    5: 'Market On Close',
};

export const OrderClassMap: any = {
    0: 'Unknown',
    1: 'Single',
    2: 'Multileg',
    Single: 1,
    Multileg: 2,
};

export const OrderStatusMap: StringMap = {
    0: 'Undefined ',
    1: 'New',
    2: 'PartiallyFilled',
    3: 'Filled',
    // 4: 'DoneForDay',
    5: 'Cancelled',
    6: 'Replaced',
    7: 'PendingCancel',
    // 8: 'CxldEndOfDay',
    9: 'Rejected',
    10: 'Suspended',
    11: 'PendingNew',
    // 12: 'Calculated',
    13: 'Expired',
    14: 'PendingReplace',
    15: 'Saved',
    // 16: 'LiveUntriggered',
    // 17: 'Scheduled',
    // 18: 'OCOUntriggered',
    // 19: 'CancelledUntriggered',
    20: 'Initiated',
    21: 'ReplaceInitiated',
    22: 'CancelInitiated',
    23: 'CancelRejected',
    // 24: 'ReplaceRejected',
    // 25: 'Busted',
    26: 'PreAllocated',
};

export const EntitlementMap: StringMap = {
    1: 'Professional User',
    2: 'Non Professional User',
    3: 'Delayed Quotes User',
};

export const StrategyMap: StringMap = {
    1: 'Single',
    2: 'Vertical',
    3: 'Calendar',
    5: 'Straddle',
    6: 'Strangle',
    7: 'Butterfly',
    8: 'Condor',
    9: 'Iron Butterfly',
    10: 'Iron Condor',
    13: 'Covered Call',
    18: 'Custom',
};
export const OrderDurationViewViewMap: any = { 1: 0, 2: 1, 3: 2, 8: 3};
export const ErrorCodeMap: StringMap  = {
  0: 'Success' ,
  100: 'TradingBlock: Incorrect User Or Pass',
  101: 'TradingBlock: Failed To Decrypt User Pass',
  102: 'TradingBlock: Failed To Decrypt Message' ,
  103: 'TradingBlock: Incorrect Entity',
  104: 'TradingBlock: Expired Request',
  105: 'TradingBlock: Failed To Parse Payload' ,
  106: 'TradingBlock: Message Is NULL' ,
  107: 'TradingBlock: Failed To Split Message' ,
  108: 'TradingBlock: Failed To Decode Header' ,
  109: 'TradingBlock: Failed To Decode Payload' ,
  110: 'TradingBlock: User Must Complete Market Data Questionnaire' ,
  111: 'TradingBlock: Too Many Failed Login Attempts' ,
  112: 'TradingBlock: No Account Found With  Api Agreement Accepted' ,
  113: 'TradingBlock: Failed To Fetch Requested Payload',
  114: 'TradingBlock: Failed To Parse Supplied Parameters' ,
  115: 'Tradingblock: Not Authorized For API Request',
  116: 'Tradingblock: Must Specify Specific AccountId',
  117: 'Tradingblock: Must Specify Specific SubaccountId',
  118: 'Tradingblock: Account Requested Does Not Have Api Agreement Accepted',
  119: 'Tradingblock: Subaccount Is Not Owned By Specified Account',
  120: 'Tradingblock: Market data policy update needed',

  200: 'Tradingblock: Not Authorized For Given Request',
  201: 'Tradingblock: User Has Access To Zero Accounts',
  202: 'Tradingblock: No Account Found With  Api Agreement Accepted',
  203: 'Tradingblock: Account Requested Does Not Have Api Agreement Accepted',
  204: 'Tradingblock: Must Specify Specific AccountId',
  205: 'Tradingblock: Must Specify Specific SubaccountId',
  206: 'Tradingblock: Subaccount Is Not Owned By Specified Account',

  300: 'Tradingblock: New order pre-validation failed; one or more order properties is invalid',
  301: 'Tradingblock: Account and/or sub-account does not have sufficient funds and/or trade would create an unauthorized strategy',
  302: 'Tradingblock: Supplied symbol for the given order is invalid',
  303: 'Tradingblock: OrderId supplied is invalid',
  304: 'Tradingblock: Order could not be found by the given OrderId',
  400: 'Tradingblock: User Must Complete Market Data Questionnaire',
};

export const OrderActionMap: any = {
        1: 'Buy To Open',
        2: 'Sell To Close',
        3: 'Sell To Open',
        8: 'Buy To Close',
};

export function ConvertOrderActionToFields(v: number) {
    let effect = 0;
    let side = 0;
    switch (v) {
        case 1:
            side = OrderAction.Buy;
            effect = PositionEffect.Open;
            break; // Buy
        case 2:
            side = OrderAction.Sell;
            effect = PositionEffect.Close;
            break; // Sell To Close
        case 3:
            side = OrderAction.Sell;
            effect = PositionEffect.Open;
            break; // Sell Short
        case 8:
            side = OrderAction.Buy;
            effect = PositionEffect.Close;
            break; // Buy To Cover
    }
    return {effect, side};
}

export function ConvertFieldsToOrderAction(effect: PositionEffect, action: OrderAction) {
    if (effect === PositionEffect.Open && action === OrderAction.Buy) { return 1; }
    if (effect === PositionEffect.Close && action === OrderAction.Sell) { return 2; }
    if (effect === PositionEffect.Open && action === OrderAction.Sell) { return 3; }
    if (effect === PositionEffect.Close && action === OrderAction.Buy) { return 8; }
    return false;
}
